import { Component } from 'react'
import { connect } from 'react-redux'
import { Notification } from '../../cdl-react-components/components'
import { popNotification } from '../../../store/actions'

class Notifications extends Component {
    state = { notification: undefined }

    handleClose = (callback) => () => this.setState({ notification: undefined }, callback)

    render() {
        const { notification } = this.state
        const callback = notification ? notification.callback : undefined
        const message = notification ? notification.message : undefined

        return (
            <Notification 
                open={notification}
                onClose={this.handleClose(callback)}>
                {message}
            </Notification>
        )
    }

    componentDidUpdate() {        
        if (!this.state.notification && this.props.notifications.length > 0) {
            setTimeout(() => {
                this.setState(
                    { notification: this.props.notifications[0] }, 
                    this.props.popNotification)
            }, 1000)
        }
    }
}

const mapStateToProps = ({ data }) => ({ notifications: data.notifications })
const mapDispatchToProps = (dispatch) => ({ popNotification: () => dispatch(popNotification()) })

export default connect(mapStateToProps, mapDispatchToProps)(Notifications)